import React, { Component } from 'react'
import './IndustryServed.css'
// let industryServed=[]
class IndustryServed extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
            industryServed:[] 
        }
    }
    
    // componentWillReceiveProps(nextProps){
    // industryServed=nextProps.transporter_data.industry_served;
    // if(industryServed==undefined || industryServed==null){
    //     industryServed=[]
    //     }
    // }

    static getDerivedStateFromProps(nextProps, prevState){
        // industryServed=nextProps.transporter_data.industry_served;
        // if(industryServed==undefined || industryServed==null){
        //     industryServed=[]
        // } 
        if(nextProps.transporter_data.industry_served===undefined||nextProps.transporter_data.industry_served===null){
            return{
                industryServed:[]
            }
        }
        else{
            return{
                industryServed:nextProps.transporter_data.industry_served
            }
        }
    }
    render() {
        let p = this.state.industryServed.map((item,i) => {
            return <div className="industriesservedcontent" key={i}><b>{(item.name===null||item.name===''||item.name===undefined)?(''): (item.name)}</b>{(item.percentage===null||item.percentage===''||item.percentage===undefined)?(''): (`: ${item.percentage}%`)}</div>
        })
        return (
            <>
                <div className="industriesservedcard">
                    <div className="industriesservedcontainer row">
                        <div className="col-12">
                            <span className="data_header">Industries Served</span>
                        </div>
                        <div className="col-12">
                            {(p.length===0)?'Details not available':p}
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default IndustryServed
